
// 定义一些公共的属性和方法
 const httpUrl = ''
// const httpUrl = 'https://devmobile.morewiscloud.com'
// const httpUrl = 'https://tmobile.morewiscloud.com'
// const httpUrl = 'https://smobile.morewiscloud.com'
// const httpUrl = 'https://mobile.morewiscloud.com'

function commonFun() {
    console.log("公共方法")
}
function commonGoback(){
    alert("我要退出")
}
// 暴露出这些属性和方法
export default {
    httpUrl,
    commonFun,
   commonGoback
}



// WEBPACK FOOTER //
// ./src/views/common.vue